import React from 'react';
import { useNavigate } from 'react-router-dom';

export const LinkToSimulator = (props: any) => {
    const navigate = useNavigate();
    const gotoSimulator = () => {
        localStorage.setItem('leadId', props.leadId)
        if (props.onClick) {
            props.onClick(props.leadId)
        }
        navigate('/Simulator');
    }
    return (
        <>
            <li className="action-btn-menu-item pointer"
                onClick={()=>{gotoSimulator()}}
            >
                סימולטור
            </li>
        </>
    )
}